import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-sm border border-gray-200 p-4" }
const _hoisted_2 = { class: "flex items-start justify-between gap-4" }
const _hoisted_3 = { class: "text-xs text-gray-600 mt-0.5" }
const _hoisted_4 = { class: "mt-3 w-full bg-gray-200 rounded-full h-2.5 overflow-hidden" }
const _hoisted_5 = { class: "mt-2 text-xs text-gray-600" }

import { computed } from "vue";

interface Props {
  current: number;
  target: number | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RandomWeightProgressCard',
  props: {
    current: {},
    target: {}
  },
  setup(__props: any) {

const props = __props;

const normalizedTarget = computed(() => {
  const target = props.target ?? 0;
  return target > 0 ? target : 0;
});

const hasTarget = computed(() => normalizedTarget.value > 0);

const progressPercentage = computed(() => {
  if (!hasTarget.value) return 0;
  return Math.min(Math.round((props.current / normalizedTarget.value) * 100), 100);
});

const remaining = computed(() => {
  if (!hasTarget.value) return 0;
  return Math.max(normalizedTarget.value - props.current, 0);
});

const progressColorClass = computed(() => {
  if (progressPercentage.value >= 100) return "bg-green-500";
  if (progressPercentage.value >= 70) return "bg-amber-500";
  return "bg-primary";
});

const percentageTextClass = computed(() => {
  if (progressPercentage.value >= 100) return "text-green-700";
  if (progressPercentage.value >= 70) return "text-amber-700";
  return "text-primary";
});

const helperText = computed(() => {
  if (!hasTarget.value) {
    return "Target amount is missing. Configure random weight target to track progress.";
  }

  if (remaining.value === 0) {
    return "Sampling target reached.";
  }

  const suffix = remaining.value === 1 ? "" : "s";
  return `Record ${remaining.value} more sample${suffix} to complete random sampling.`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, "Random Weights Progress", -1)),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.current) + " / " + _toDisplayString(hasTarget.value ? normalizedTarget.value : "?") + " recorded ", 1)
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["text-sm font-semibold", percentageTextClass.value])
      }, _toDisplayString(progressPercentage.value) + "% ", 3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["h-2.5 rounded-full transition-all duration-500 ease-out", progressColorClass.value]),
        style: _normalizeStyle({ width: `${progressPercentage.value}%` })
      }, null, 6)
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(helperText.value), 1)
  ]))
}
}

})